import { StyledTooltip } from "../../SchoolProfileView.styled";
import React from "react";

export const MeterBreakdownTooltip = ({
  resourceType,
  children,
  gridVMs,
  user,
  api,
}) => {
  const getTitle = () => {
    // resource error
    if (resourceType !== "sites") {
      return "This is not available for organisation level resources";
    }

    // logged in error
    if (typeof user === "undefined" || !user) {
      return "You need to be logged in to view this resource";
    }

    // endpoint error
    if (gridVMs && gridVMs.message === "Request failed with status code 401") {
      if (api.validToken()) {
        return "Your session may have expired, try logging out and in again.";
      } else {
        return "You need to be logged in to view this resource";
      }
    }

    return "";
  };

  return <StyledTooltip title={getTitle()}>{children}</StyledTooltip>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GraphHeader/MeterBreakdownTooltip.js